import React from 'react';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import FPIconButton from 'UI/components/atoms/FPIconButton';
import TextBox from 'UI/components/atoms/TextBox';
import FileItem from 'UI/components/molecules/FileItem';
import { FILE_ACTIONS } from 'UI/components/molecules/FileItem/FileItem.constants';
import { colors, SvgUploadButton } from 'UI/res';

import { useOfferLetterUpload } from './OfferLetterAttachment.hooks';
import { useStyles } from './OfferLetterAttachment.styled';

export const OfferLetterAttachment = ({
  acceptFiles = [],
  disabled = false,
  file = null,
  label = 'Offer Letter',
  onTempFileUploaded,
  uploadEndpoint
}) => {
  const { currentFile, inputRef, isUploading, isSaving, error, openFilePicker, handleInputChange } =
    useOfferLetterUpload({
      file,
      uploadEndpoint,
      onTempFileUploaded,
      disabled
    });
  const classes = useStyles();

  const isInputDisabled = disabled || isUploading || isSaving;
  const handleIconClick = event => {
    event.stopPropagation();
    openFilePicker();
  };

  return (
    <div>
      {currentFile && (
        <List>
          <FileItem
            file={currentFile}
            fileName={currentFile?.file_name || currentFile?.original_name}
            error={Boolean(error)}
            loading={Boolean(currentFile?.isLoading) || isUploading || isSaving}
            message={error}
            showFileSize
            showMenu
            showSelector={false}
            allowedActions={[FILE_ACTIONS.View, FILE_ACTIONS.Download]}
          />
        </List>
      )}

      <input
        ref={inputRef}
        type="file"
        hidden
        multiple={false}
        accept={acceptFiles.join(',')}
        onChange={handleInputChange}
      />

      <TextBox
        name="offer_letter_uploader"
        label={label}
        labelAsPlaceholder={false}
        onClick={openFilePicker}
        className={classes.categoryFieldManual}
        aria-label={`${label} File Selector`}
        InputProps={{
          readOnly: true,
          startAdornment: (
            <div className={classes.placeholderSelectorContainer}>
              <Typography className={classes.placeholderSelectorText}>
                {strings.shared.ui.selectFile}
              </Typography>
            </div>
          ),
          endAdornment: !isInputDisabled && (
            <div className="MuiAutocomplete-endAdornment">
              <FPIconButton
                onClick={handleIconClick}
                icon={SvgUploadButton}
                iconProps={{ color: colors.oxford }}
                disabled={isInputDisabled}
                tooltipProps={{ title: strings.shared.ui.selectFile }}
              />
            </div>
          )
        }}
        disabled={isInputDisabled}
      />

      {!currentFile && error && (
        <Typography color="error" variant="body2">
          {error}
        </Typography>
      )}
    </div>
  );
};
